import { useQuery } from '@tanstack/react-query';
import { getQRCode, QRCodeResponse } from '@/api/wallet';

/**
 * ユーザーのQRコードデータを取得するカスタムHook
 */
export const useQRData = () => {
  return useQuery<QRCodeResponse, Error>({
    queryKey: ['qrCode'],
    queryFn: getQRCode,
    // staleTime: 1000 * 60 * 5, // 5分間はキャッシュを使用
    refetchOnWindowFocus: true, // ウィンドウフォーカス時に再取得
  });
};
